// removed by extract-text-webpack-plugin
module.exports = {"masthead":"src-components-Masthead----Masthead-module---masthead---2T9q-","mastheadInner":"src-components-Masthead----Masthead-module---mastheadInner---19b4E","mastheadTitle":"src-components-Masthead----Masthead-module---mastheadTitle---2R4uc","brand":"src-components-Masthead----Masthead-module---brand---3Te7a","mastheadNav":"src-components-Masthead----Masthead-module---mastheadNav---uG8zX","active":"src-components-Masthead----Masthead-module---active---NjbcV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Masthead/Masthead.module.scss
// module id = 269
// module chunks = 22676092666560